"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.mintNewEditionFromMasterEditionViaToken = exports.getMintNewEditionFromMasterEditionViaTokenInstructionDataSerializer = void 0;
const umi_1 = require("@metaplex-foundation/umi");
const serializers_1 = require("@metaplex-foundation/umi/serializers");
const shared_1 = require("../shared");
const types_1 = require("../types");
function getMintNewEditionFromMasterEditionViaTokenInstructionDataSerializer() {
    return (0, serializers_1.mapSerializer)((0, serializers_1.struct)([
        ['discriminator', (0, serializers_1.u8)()],
        [
            'mintNewEditionFromMasterEditionViaTokenArgs',
            (0, types_1.getMintNewEditionFromMasterEditionViaTokenArgsSerializer)(),
        ],
    ], { description: 'MintNewEditionFromMasterEditionViaTokenInstructionData' }), (value) => ({ ...value, discriminator: 11 }));
}
exports.getMintNewEditionFromMasterEditionViaTokenInstructionDataSerializer = getMintNewEditionFromMasterEditionViaTokenInstructionDataSerializer;
// Instruction.
function mintNewEditionFromMasterEditionViaToken(context, input) {
    // Program ID.
    const programId = context.programs.getPublicKey('mplTokenMetadata', 'metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s');
    // Accounts.
    const resolvedAccounts = {
        newMetadata: {
            index: 0,
            isWritable: true,
            value: input.newMetadata ?? null,
        },
        newEdition: {
            index: 1,
            isWritable: true,
            value: input.newEdition ?? null,
        },
        masterEdition: {
            index: 2,
            isWritable: true,
            value: input.masterEdition ?? null,
        },
        newMint: {
            index: 3,
            isWritable: true,
            value: input.newMint ?? null,
        },
        editionMarkPda: {
            index: 4,
            isWritable: true,
            value: input.editionMarkPda ?? null,
        },
        newMintAuthority: {
            index: 5,
            isWritable: false,
            value: input.newMintAuthority ?? null,
        },
        payer: {
            index: 6,
            isWritable: true,
            value: input.payer ?? null,
        },
        tokenAccountOwner: {
            index: 7,
            isWritable: false,
            value: input.tokenAccountOwner ?? null,
        },
        tokenAccount: {
            index: 8,
            isWritable: false,
            value: input.tokenAccount ?? null,
        },
        newMetadataUpdateAuthority: {
            index: 9,
            isWritable: false,
            value: input.newMetadataUpdateAuthority ?? null,
        },
        metadata: {
            index: 10,
            isWritable: false,
            value: input.metadata ?? null,
        },
        tokenProgram: {
            index: 11,
            isWritable: false,
            value: input.tokenProgram ?? null,
        },
        systemProgram: {
            index: 12,
            isWritable: false,
            value: input.systemProgram ?? null,
        },
        rent: {
            index: 13,
            isWritable: false,
            value: input.rent ?? null,
        },
    };
    // Arguments.
    const resolvedArgs = {
        ...input,
    };
    // Default values.
    if (!resolvedAccounts.payer.value) {
        resolvedAccounts.payer.value = context.payer;
    }
    if (!resolvedAccounts.tokenProgram.value) {
        resolvedAccounts.tokenProgram.value = context.programs.getPublicKey('splToken', 'TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA');
        resolvedAccounts.tokenProgram.isWritable = false;
    }
    if (!resolvedAccounts.systemProgram.value) {
        resolvedAccounts.systemProgram.value = context.programs.getPublicKey('splSystem', '11111111111111111111111111111111');
        resolvedAccounts.systemProgram.isWritable = false;
    }
    // Accounts in order.
    const orderedAccounts = Object.values(resolvedAccounts).sort((a, b) => a.index - b.index);
    // Keys and Signers.
    const [keys, signers] = (0, shared_1.getAccountMetasAndSigners)(orderedAccounts, 'omitted', programId);
    // Data.
    const data = getMintNewEditionFromMasterEditionViaTokenInstructionDataSerializer().serialize(resolvedArgs);
    // Bytes Created On Chain.
    const bytesCreatedOnChain = 0;
    return (0, umi_1.transactionBuilder)([
        { instruction: { keys, programId, data }, signers, bytesCreatedOnChain },
    ]);
}
exports.mintNewEditionFromMasterEditionViaToken = mintNewEditionFromMasterEditionViaToken;
//# sourceMappingURL=mintNewEditionFromMasterEditionViaToken.js.map